import { render, staticRenderFns } from "./TrademarkPriorityList.vue?vue&type=template&id=365c7482&"
import script from "./TrademarkPriorityList.vue?vue&type=script&lang=js&"
export * from "./TrademarkPriorityList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkPriorityList.vue?vue&type=style&index=0&id=365c7482&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports